import React, { useState } from "react";
import { HeroSection } from "./styles.js";
import { useTheme } from "../Theme/ThemeProvider.js";
import MainHeading from "../MainHeading/index.js";
import QrCode from "../QrCode/index.js";
import WhySection from "../WhySection/index.js";
import NoSecret from "../NoSecret/index.js";
import WeResolve from "../WeResolve/index.js";

export default function AboutUs() {
  const { isDarkMode } = useTheme();
  const [showQrModal, setShowQrModal] = useState(false);

  const toggleQrModal = () => setShowQrModal((prev) => !prev);
  return (
    <HeroSection isDarkMode={isDarkMode}>
      <MainHeading
        toggleQrModal={toggleQrModal}
        title={
          <>
            Nós somos uma startup de{" "}
            <span className="DescriptionSubtext">identidade</span>, e{" "}
            <span className="DescriptionSubtext">gestão de acesso</span>
          </>
        }
        description="Baseado em SaaS combinamos expertise em IA e segurança digital com uma filosofia centrada no usuário para o combate a
fraudadores digitais."
      />
      <NoSecret />
      <WeResolve />
      <WhySection />
      {showQrModal && <QrCode onClose={toggleQrModal} />}
    </HeroSection>
  );
}
